import React from 'react';
import styled from 'styled-components';
import { BORDER_RADIUS } from '../../constants';
import { IconTick } from '../../icon/IconTick';
import { IconProps } from '../../icon/icon_props';

interface Props {
  onClick: () => void;
  styles?: string;
}

export const ButtonSimple = styled.div<{ styles?: string }>`
  background: #fff;
  border: 1px solid #c5c5c5;
  border-radius: ${BORDER_RADIUS};
  color: #333;
  padding: 0.15rem 0.5rem;
  letter-spacing: .05rem;
  font-size: .85rem;

  & *:hover,:hover {
    cursor: pointer;
  }

  ${(props) => props.styles}
`;

export const ButtonPrimary = styled.div<{ styles?: string }>`
  border: 0;
  border-radius: ${BORDER_RADIUS};
  padding: 0.25rem 0.75rem;

  & *:hover,:hover {
    cursor: pointer;
  }

  ${(props) => props.styles}
`;

const B = (props: Props & { children?: any }) => (
  <ButtonPrimary
    className="__primary-highlight-background-color __primary-highlight-foreground-color"
    onClick={props.onClick}
    styles={props.styles}
  >
    {props.children}
  </ButtonPrimary>
);

const ButtonBase = styled.button`
  align-items: center;
  border: 0;
  border-radius: ${BORDER_RADIUS};
  display: flex;
  padding: 0.25rem 0.75rem;
  opacity: ${(props) => (props?.disabled ? 0.3 : 1)};

  & *:hover,:hover {
    cursor: pointer;
  }
`;

interface ButtonGoGoProps {
  disabled?: boolean;
  Icon: (props: IconProps) => JSX.Element;
  onClick: () => void;
  text: string;
}

const ButtonGoGoLabel = styled.label`
    display: inline-block;
    font-weight: bold;
    padding: .2rem .4rem;
    vertical-align: middle;
  `;

const ButtonGoGo = (props: ButtonGoGoProps) => {
  const { Icon, onClick, text } = props;

  return (
    <ButtonBase
      className="__primary-highlight-background-color __primary-highlight-foreground-color"
      disabled={props?.disabled ?? false}
      onClick={onClick}
    >
      <Icon
        className="__primary-color"
        style={{
          height: '1.3rem', width: '1.3rem', iconBg: '#fff', iconFg: 'currentColor',
        }}
      />
      <ButtonGoGoLabel>{text}</ButtonGoGoLabel>
    </ButtonBase>
  );
};

export const ButtonSubmit = (props: ButtonGoGoProps) => <ButtonGoGo {...props} Icon={IconTick} />;

export default B;
